import app_config from "../../common/data/app_config";
import { getStorage } from "../../utilities/setting";
import axios from "axios";

const uploadService = async (endpoint, data) => {
  let accessToken = "";
  if (!accessToken) {
    accessToken = getStorage("access_token")
      ? `Bearer ${getStorage("access_token")}`
      : "";
  }
  try {
    let apiEndpoint = "";
    // if first character of endpoint is /, then return new endpoint by removing / character
    if (endpoint.charAt(0) === "/") {
      apiEndpoint = endpoint.substring(1);
    } else {
      apiEndpoint = endpoint;
    }
    let response = await axios({
      method: "POST",
      url: app_config.api_url + "/" + apiEndpoint,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: accessToken,
      },
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return null;
  }
};

export default uploadService;
